var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShowAssets = function SvgShowAssets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 2.5,
    d: "M10 29.958c.214 2.18.7 3.648 1.795 4.744 1.965 1.965 5.128 1.965 11.453 1.965 6.326 0 9.488 0 11.454-1.965 1.965-1.965 1.965-5.128 1.965-11.454 0-6.325 0-9.488-1.965-11.453-1.096-1.096-2.564-1.58-4.744-1.795"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 2.5,
    d: "M3.332 16.667c0-6.285 0-9.428 1.953-11.38 1.952-1.953 5.095-1.953 11.38-1.953s9.429 0 11.381 1.953c1.953 1.952 1.953 5.095 1.953 11.38s0 9.429-1.953 11.381c-1.953 1.953-5.095 1.953-11.38 1.953s-9.429 0-11.381-1.953c-1.953-1.952-1.953-5.095-1.953-11.38Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 2.5,
    d: "M3.332 18.532a24 24 0 0 1 3.12-.194c4.42-.082 8.731 1.123 12.165 3.4 3.185 2.112 5.423 5.018 6.382 8.263"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5,
    d: "M21.668 11.666h.015"
  })));
};
export default SvgShowAssets;